/**
 * @generated SignedSource<<d8acaec230f62ba526ddc595cd032d82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubjectSubscriptionButtonUnsubscribeMutation$variables = {
  subscription: string;
};
export type SubjectSubscriptionButtonUnsubscribeMutation$data = {
  readonly unsubscribeFromSubject: string;
};
export type SubjectSubscriptionButtonUnsubscribeMutation = {
  response: SubjectSubscriptionButtonUnsubscribeMutation$data;
  variables: SubjectSubscriptionButtonUnsubscribeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subscription"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "subscription",
        "variableName": "subscription"
      }
    ],
    "kind": "ScalarField",
    "name": "unsubscribeFromSubject",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubjectSubscriptionButtonUnsubscribeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubjectSubscriptionButtonUnsubscribeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf335298b64f66b205b6ceb8b18291f3",
    "id": null,
    "metadata": {},
    "name": "SubjectSubscriptionButtonUnsubscribeMutation",
    "operationKind": "mutation",
    "text": "mutation SubjectSubscriptionButtonUnsubscribeMutation(\n  $subscription: ID!\n) {\n  unsubscribeFromSubject(subscription: $subscription)\n}\n"
  }
};
})();

(node as any).hash = "b082fc64d1693406f1b1e44cae5f0683";

export default node;
